import React ,{useEffect, useState}from 'react';
import { useNavigate } from 'react-router-dom';
import { getYear, getYearMonth, getRemittanceReports, getRemittanceReportsPDF } from '../Services/loadOrder';
import MenuBar from './common/MenuBar';
import { DataGrid} from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { ChevronLeft, ChevronRight, Inbox, FileDown } from 'lucide-react';
import '../assets/css/home.css';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import toast,{ Toaster} from 'react-hot-toast';

function CustomInboxOverlay() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            }}
        >
            <Inbox size={48} color="#ec008c" />
            <span style={{ marginTop: 12, fontSize: 18, color: '#888' }}>No Data Found</span>
        </Box>
    );
}

const Remittance = () => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const pharmacyId = user?.pharmacyId;
    const userId = user?.userId;
      const [searchText, setSearchText] = useState('');
    const [yearOptions, setYearOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [apiReportData, setApiReportData] = useState([]);
    //const [flag, setFlag] = useState('Y');
   // const [monthOptions, setMonthOptions] = useState([]);

    useEffect(() => {
        const fetchYearMonth = async () => {
            if (!pharmacyId || !userId) {
                console.error("Pharmacy ID or User ID is missing");
                return;
            }
            console.log("Fetching year and month with pharmacyId:", pharmacyId, "and userId:", userId);
            const result = await getYear(pharmacyId, userId);
            console.log("Remitance year response", result);
            
            if (result) setYearOptions(result);

            if (year !== '') {
               const result = await getYearMonth(pharmacyId, userId, year);
            console.log("Remitance year response", result);
            
            if (result) setMonthOptions(result);
            }

           // if (result.month) setMonthOptions(result.month);
        };
        fetchYearMonth();
    }, [pharmacyId, userId, year]);
    
    // useEffect(() => {
    //     const fetchMonth = async () => {
    //         if (!pharmacyId || !userId || !year) {
    //             console.error("Pharmacy ID or User ID is missing");
    //             return;
    //         }
    //         console.log("Fetching year and month with pharmacyId:", pharmacyId, "and userId:", userId);
    //         const result = await getYearMonth(pharmacyId, userId, year);
    //         console.log("Remitance year response", result);
            
    //         if (result) setMonthOptions(result);

    //        // if (result.month) setMonthOptions(result.month);
    //     };
    //     fetchMonth();
    // }, [pharmacyId, userId, year]);

    
    // Add months and years data
    
     const handleSearch = async () => {
        // ...existing code...
        try {
            const reports = await getRemittanceReports(pharmacyId, userId, month, year);
            // Add id property to each row (use Referencenumber or ChequeNumber if unique)
            if (reports.length === 0) {
                toast.error("No Data Found");
               return;
            }
            const rowsWithId = reports.map((row, idx) => ({
                ...row,
                id: `${row.Referencenumber}_${row.EFTnumber}` || idx // or add idx if needed for extra safety
            }));
            setApiReportData(rowsWithId);
        } catch (error) {
            console.error("Error fetching remittance reports:", error);
        }
    }

    const handlePdfClick = async (params) => {
    try {
        const response = await getRemittanceReportsPDF(
            pharmacyId,
            userId,
            params.row.ChequeNumber,
            params.row.Referencenumber,
            params.row.EFTnumber,
            params.row.Contract
        );
        // If your API returns a Blob:
        if (response.fileUrl) {
            window.open(response.fileUrl, '_blank');
        } else {
            console.error("No PDF URL returned from API");
        }
    } catch (error) {
       toast.error("Document not Found");
        console.error("Error downloading PDF:", error);
    }
};

    const columns = [
    { field: 'Contract', headerName: 'Contract', flex: 2, headerClassName: 'pink-header', sortable: false },
    { field: 'Referencenumber', headerName: 'Reference Number', flex: 1, headerClassName: 'pink-header', sortable: false },
    { field: 'ChequeNumber', headerName: 'Cheque Number', flex: 1, headerClassName: 'pink-header', sortable: false },
    { field: 'EFTnumber', headerName: 'EFT Number', flex: 1, headerClassName: 'pink-header', sortable: false },
    { field: 'GeneratedDate', headerName: 'Generated Date', flex: 1, headerClassName: 'pink-header', sortable: false },
    { field: 'Amount', headerName: 'Amount', flex: 1, headerClassName: 'pink-header', sortable: false ,
    renderCell: (params) => `$${params.value.toFixed(2)}`  
    },
   {
    field: 'DownloadPDF',
    headerName: 'Download PDF',
    flex: 1,
    headerClassName: 'pink-header',
    sortable: false,
    renderCell: (params) => (
        <FileDown
            style={{ cursor: 'pointer', width: 32, height: 32, color: '#ec008c' }}
            onClick={() => handlePdfClick(params)}
        />
    ),
},
];

const filteredData = apiReportData.filter(row =>
  row.EFTnumber && row.EFTnumber.toString().toLowerCase().includes(searchText.toLowerCase())
);

// const amountToDollar = (amount) => {
//   return `$${amount.toFixed(2)}`;
// }

    return (
        <div>
            <MenuBar />
            <Toaster position="top-right"  />
            <div className='top-page-option'>
                <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
                    <a 
                                href="#/home" 
                                style={{
                                  textDecoration: 'none',
                                  color: '#ec088c',
                                  display: 'inline-flex',
                                  alignItems: 'center'
                                }}
                              >
                                <ChevronLeft color='#ec088c' size={18} />
                                <span style={{ marginLeft: '5px' }}>Back</span>
                              </a>
                </div>
        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <span>Dispensed Order</span>
                    <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }} />
                    <span>Remittance Reports</span>

                    <div style={{ display: 'flex',justifyContent:'right', alignItems: 'center', gap: '8px' ,marginLeft:'auto', marginRight:'6.2%' }}>           
                                   <label>Year:</label>
                        <FormControl
  size="small"
  sx={{
    minWidth: 100,
    height: '30px',
    background: '#fff',
    borderRadius: '4px',
    marginRight: '10px'
  }}
>
  <InputLabel
    sx={{
      fontFamily: 'Segoe ui',
      marginBottom: '10px',
      background: '#fff',
      color: 'black',
      fontSize: '12px'
    }}
    id="year-select-label"
  >
Select Year
  </InputLabel>
  <Select
    labelId="year-select-label"
    value={year}
    label="--Select Year--"
    onChange={e => setYear(e.target.value)
      }
    sx={{
      fontFamily: 'Segoe ui',
      fontSize: '12px',
      border: '1px solid rgb(236, 151, 202)',
      borderRadius: '15px',
      height: '30px',
      boxShadow: 'none',
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c',
        boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c',
      },
    }}
  >
    <MenuItem value="" sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}>
    Select Year
    </MenuItem>
    {yearOptions.map(year => (
  <MenuItem
    key={year}
    value={year}
    sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}
  >
    {year}
  </MenuItem>
))}
  </Select>
</FormControl>
                    
                        <label>Month:</label>
                        <FormControl
  size="small"
  sx={{
    minWidth: 120,
    height: '30px',
    background: '#fff',
    borderRadius: '4px',
    marginRight: '10px'
  }}
>
  <InputLabel
    sx={{
      fontFamily: 'Segoe ui',
      marginBottom: '10px',
      background: '#fff',
      color: 'black',
      fontSize: '12px'
    }}
    id="month-select-label"
  >
    Select Month
  </InputLabel>
  <Select
    labelId="month-select-label"
    value={month}
    label="Select Month"
    onChange={e => setMonth(e.target.value)}
    disabled={!year}
    sx={{
      fontFamily: 'Segoe ui',
      fontSize: '12px',
      border: '1px solid rgb(236, 151, 202)',
      borderRadius: '15px',
      height: '30px',
      boxShadow: 'none',
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c',
        boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ec008c',
      },
    }}
  >
    <MenuItem value="" sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}>
      Select Month
    </MenuItem>
    {monthOptions.map(month => (
  <MenuItem
    key={month}
    value={month}
    sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}
  >
    {month}
  </MenuItem>
))}
  </Select>
</FormControl>
                    
                    <button
                        style={{
                            backgroundColor: '#ec088c',
                            color: 'white',
                            border: 'none',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                            handleSearch();
                            // Add search functionality here
                            console.log('Search clicked');
                        }}
                    >
                        Search
                    </button>
                </div>
                </div>         
            </div>

            { apiReportData.length > 0 &&(
              <div style={{ display: 'flex',justifyContent:'right', alignItems: 'center', gap: '8px' ,marginLeft:'auto', marginRight:'7.2%' }}>
              <input
                type="text"
                placeholder="Search by EFT Number"
                value={searchText}
                onChange={e => setSearchText(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleSearch(); }}
                style={{
                  padding: '5px 5px',
                  borderRadius: '15px', 
                  border: '1px solid rgb(236, 151, 202)', outline: 'none',
                  boxShadow : '0 1px 2px rgb(236, 151, 202)',
                  transition: 'all 0.3s ease'
                }}
                onFocus={(e) => {
                  e.target.style.border = '1px solid #ec008c';
                  e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
                }}
                onBlur={(e) => {
                  e.target.style.border = '1px solid rgb(236, 151, 202)';
                  e.target.style.boxShadow = '0 1px 2px rgb(236, 151, 202)';
                }}
              />
            </div>)}
            

            {/* <div className="outer-box" style={{
                background: '#fff',
                padding: '20px',
                borderRadius: '10px',
                margin: '20px 100px'
            }}> */}
                {/* Filter controls aligned to right */}
                {/* <div style={{ 
                    display: 'flex',
                    gap: '20px',
                    marginBottom: '20px',
                    alignItems: 'center',
                    justifyContent: 'flex-end'  // Add this to align to right
                }}> */}
 

                      <div style={{ height: '60vh', width: '87%', margin: 'auto', marginTop: '20px' }}>

                   
    <DataGrid
        rows={filteredData}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        hideFooter
        sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
                color: '#fff',
                backgroundColor: '#ec008c',
                fontWeight: 'bold',
                whiteSpace: 'normal !important',
                wordBreak: 'break-word !important',
                overflowWrap: 'break-word !important',
                lineHeight: '1.3 !important',
                textAlign: 'center',
                padding: '8px 2px !important',
            },
            '& .MuiDataGrid-row:hover': {
                backgroundColor: '#f5f5f5 !important',
                cursor: 'pointer',
            },
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
                backgroundColor: 'none !important',
            },
            '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
            },
        }}
        slots={{
        noRowsOverlay: CustomInboxOverlay
    }}
    />

                </div>
            </div>
        // </div>
    );
};

export default Remittance;

